import {makeAutoObservable} from 'mobx'
import * as Api from '@/utils/api/api'
import CollectEnum from '@/enum/CollectEnum'

class DetailStore {
    goodsId = 0
    type = 0
    num = 1
    // @observable _product = null
    skuList = [];
    currentSku = null;
    goods = null
    hasCollect = false
    collectId = 0
    goodsAttributeList = []
    specificationMapList = {}
    goodsPromotionUrl = ''
    description = ''
    cartCount = 0
    goodsPropList = []

    constructor() {
        makeAutoObservable(this)
    }
    /**
     * 初始化
     */
    init() {
        this.goodsId = 0
        this.type = 0
        this.num = 1
        this.skuList = [];
        this.currentSku = null
        this.goods = null
        this.hasCollect = false
        this.collectId = 0
        this.goodsAttributeList = []
        this.specificationMapList = []
        this.goodsPromotionUrl = ''
        this.description = ''
    }

    /**
     * 获取信息
     */
    
    async fetchInfo() {
        try {
            const {goodsId, type} = this

            let {
                skuList,
                goods,
                hasCollect,
                collectId,
                goodsAttributeList,
                specificationMapList,
                goodsPromotionUrl
            } = await Api.goodsInfo({goodsId, type});


            if (skuList && skuList.length) {

                let currentSku = skuList.find(sku => sku.id === goods.primaryProductId);
                /**
                 * 设置规格
                 */
                let selectedSpecificationIdList = currentSku.goodsSpecificationIds
                    ?.split("_")
                    .map(id => Number(id));

                let mapList = [];
                for (let key in specificationMapList) {
                    let specificationList = specificationMapList[key];

                    let map = {};
                    map.list = [...specificationList];
                    map.currentIndex = 0;

                    for (let i = 0; i < specificationList.length; i++) {
                        if (selectedSpecificationIdList.indexOf(specificationList[i].id) !== -1) {
                            map.currentIndex = i;
                            break;
                        }
                    }

                    mapList[key] = map;
                }

                this.skuList = skuList;
                this.currentSku = currentSku;
                this.specificationMapList = {...mapList};
                this.hasCollect = hasCollect;
                this.collectId = collectId;
            }

            if (goods.description) {
                this.description = goods.description;
            }
            if (goodsPromotionUrl) {
                this.goodsPromotionUrl = goodsPromotionUrl;
            }

            if (goods) {
                this.goods = goods;
            }
            if (goodsAttributeList) {
                this.goodsAttributeList = goodsAttributeList;
            }
        } catch (e) {
        }
    }

    
    selectSpecification({key, index}) {
        let specificationMapList = {...this.specificationMapList};
        specificationMapList[key].currentIndex = index;
        this.specificationMapList = specificationMapList;

        let currentSpecificationIdList = [];
        for (let key in specificationMapList) {
            let value = specificationMapList[key];
            currentSpecificationIdList.push(value.list[value.currentIndex].id);
        }

        this.currentSku = this.skuList.find(sku => {
            let skuSpecificationIdList = sku.goodsSpecificationIds.split("_").map(item => Number(item));

            let isOk = true;
            currentSpecificationIdList.forEach(currentSpecificationId => {
                if (!skuSpecificationIdList.includes(currentSpecificationId)) {
                    isOk = false;
                }
            })

            return isOk;
        })
    }

    get imgList() {

        let imgList = [];

        /*
        * 填充sku的图片列表
        * */
        if (this.currentSku?.skuPicList?.length) {
            imgList = [...this.currentSku.skuPicList?.split(";")];
        }

        /*
        * 填充商品的图片列表
        * */
        if (this.goods?.imgList?.length) {
            imgList = [...imgList, ...this.goods.imgList.split(";")];
        }
        if (this.goods?.mainPic) {
            imgList = [...imgList, this.goods.mainPic]
        }

        return imgList;
    }

     addNum() {
        this.num++
    }

    subNum() {
        this.num--
    }

    /**
     * 收藏点击事件
     */
    
    async switchCollect() {
        try {
            const {hasCollect, collectId, goods} = this
            if (hasCollect) {
                await Api.cancelCollect({collectId})
            } else {
                const {collectId: cid} = await Api.addCollect({
                    id: goods.id,
                    type: CollectEnum.GOODS
                })
                this.collectId = cid
            }
        } catch (error) {
        }
    }

    
    async fetchCartCount() {
        try {
            const {count} = await Api.cartGoodsCount()
            this.cartCount = count
        } catch (error) {
        }
    }
}

const store = new DetailStore()

export default store
